<div class="progress">
  <div class="progress-bar" role="progressbar" [ngStyle]="{ width: progress + '%' }"></div>
</div>
